import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../../shared/cn';
export type SectionNavItem = {
  id: number;
  title: string;
};
type StickyNavbarProps = {
  sections: SectionNavItem[];
  activeSectionId: number;
};
export function StickyNavbar(t0) {
  const $ = _c(7);
  const {
    sections,
    activeSectionId
  } = t0;
  const handleClick = _temp;
  let t1;
  if ($[0] !== activeSectionId || $[1] !== sections) {
    let t2;
    if ($[3] !== activeSectionId) {
      t2 = section_0 => <button type="button" key={section_0.id} onClick={() => handleClick(section_0.id)} className={cn("block rounded-lg px-3 py-2 text-left font-medium text-slate-600 text-sm hover:bg-slate-50", activeSectionId === section_0.id && "font-bold text-slate-900")}>{section_0.title}</button>;
      $[3] = activeSectionId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = sections.map(t2);
    $[0] = activeSectionId;
    $[1] = sections;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <nav className="flex flex-col gap-2">{t1}</nav>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(id) {
  const section = document.getElementById(`${id}`);
  if (section) {
    window.scrollTo({
      top: section.getBoundingClientRect().top + window.scrollY - 40,
      behavior: "smooth"
    });
  }
}